<template>
  <loading-overlay v-if="route.meta.authRequired && !company.id" />
  <div
    v-else
    class="min-h-full bg-background bg-cover bg-fixed"
    :class="{ 'h-full': !route.meta.authRequired }"
  >
    <navigation-menu v-if="route.meta.authRequired" />
    <router-view
      :class="route.meta.authRequired ? 'pt-24 md:ml-72' : null"
      class="h-full"
    />
    <div class="absolute top-6 right-6 flex flex-col gap-2">
      <toast
        v-for="toast in toasts"
        :key="toast.id"
        :content="toast.content"
        :id="toast.id"
        :life="toast.life"
        :severity="toast.severity"
        @destroy="destroyToast"
      />
    </div>
  </div>
</template>

<script>
import { computed, ref, watch } from "vue";
import { useRoute } from "vue-router";
import { useStore } from "vuex";
import LoadingOverlay from "./components/loading/LoadingOverlay.vue";
import NavigationMenu from "./components/navigation/NavigationMenu.vue";
import Toast from "./components/toast/Toast.vue";
export default {
  components: { LoadingOverlay, NavigationMenu, Toast },
  setup() {
    const route = useRoute();
    const store = useStore();

    const counter = ref(0);
    const toasts = ref([]);

    const destroyToast = (id) => {
      const index = toasts.value.findIndex((toast) => toast.id == id);
      if (index != -1) {
        toasts.value.splice(index, 1);
      }
    };

    watch(
      () => store.state.authentication.status,
      (status) => {
        if (status.error) {
          toasts.value.push({
            content: status.error,
            id: counter.value,
            life: 3000,
            severity: "error",
          });
          counter.value++;
        }
        if (status.success) {
          toasts.value.push({
            content: status.success.code,
            id: counter.value,
            life: 3000,
            severity: "success",
          });
          counter.value++;
        }
      },
      { deep: true }
    );

    watch(
      () => store.state.estate.status,
      (status) => {
        if (status.error) {
          toasts.value.push({
            content: status.error,
            id: counter.value,
            life: 3000,
            severity: "error",
          });
          counter.value++;
        }
        if (status.success) {
          toasts.value.push({
            content: status.success.code,
            id: counter.value,
            life: 6000,
            severity: "success",
          });
          counter.value++;
        }
      },
      { deep: true }
    );

    watch(
      () => store.state.user.status,
      (status) => {
        if (status.error) {
          toasts.value.push({
            content: status.error,
            id: counter.value,
            life: 3000,
            severity: "error",
          });
          counter.value++;
        }
        if (status.success) {
          toasts.value.push({
            content: status.success.code,
            id: counter.value,
            life: 6000,
            severity: "success",
          });
          counter.value++;
        }
      },
      { deep: true }
    );

    return {
      company: computed(() => store.state.company.company),
      destroyToast,
      route,
      toasts,
    };
  },
};
</script>

<style>
* {
  margin: 0;
  box-sizing: border-box;
}

html,
body {
  height: 100%;
  overscroll-behavior: none;
}

html,
body,
#app {
  height: 100%;
}
</style>
